module.exports = __webpack_public_path__ + "img/11.bdea8159.jpg";